/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { conversationShow } from '../../axios/conversationShow'
import type {
	ConversationShowError,
	ConversationShowPathParams,
	ConversationShowResponse,
} from '../../types/ConversationShow'

export const conversationShowQueryKey = (conversationId: ConversationShowPathParams['conversationId']) =>
	[{ url: '/ai/conversations/:conversationId', params: { conversationId } }] as const

export type ConversationShowQueryKey = ReturnType<typeof conversationShowQueryKey>

/** @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::show */
export function conversationShowQueryOptions(
	conversationId: ConversationShowPathParams['conversationId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		ConversationShowResponse,
		AxiosError<ConversationShowError>,
		ConversationShowResponse,
		ConversationShowQueryKey
	>({
		queryKey: conversationShowQueryKey(conversationId),
		queryFn: ({ signal }) => conversationShow(conversationId, { signal, ...config }).then(res => res.data),
		enabled: !!conversationId,
	})
}

/** @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::show */
export function useConversationShow<TSelectData = ConversationShowResponse>(
	conversationId: ConversationShowPathParams['conversationId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					ConversationShowResponse,
					AxiosError<ConversationShowError>,
					TSelectData,
					ConversationShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<ConversationShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...conversationShowQueryOptions(conversationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/AIAssistant/Http/Controllers/ConversationController.php ConversationController::show */
export function useConversationShowSuspense<TSelectData = ConversationShowResponse>(
	conversationId: ConversationShowPathParams['conversationId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					ConversationShowResponse,
					AxiosError<ConversationShowError>,
					TSelectData,
					ConversationShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<ConversationShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...conversationShowQueryOptions(conversationId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
